import { NxBadgeModule } from "@allianz/ng-aquila/badge";
import { NxCardModule } from "@allianz/ng-aquila/card";
import { NxCopytextModule } from "@allianz/ng-aquila/copytext";
import { NxHeadlineModule } from "@allianz/ng-aquila/headline";
import { NxIconModule } from "@allianz/ng-aquila/icon";
import { CommonModule } from "@angular/common";
import { Component, DestroyRef, inject, Input, OnInit } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import moment from "moment";
import { CONSTANTS } from "src/app/shared/enums/index.enum";
import { LayoutBreakPointsService } from "src/app/shared/services/layout-break-points.service";
@Component({
  selector: "app-event-card",
  templateUrl: "./event-card.component.html",
  styleUrls: ["./event-card.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    NxBadgeModule,
    NxCardModule,
    NxCopytextModule,
    NxHeadlineModule,
    NxIconModule,
  ],
})
export class EventCardComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);

  @Input() public data;
  private desktopScreen;
  constructor(
    private readonly layoutBreakPointService: LayoutBreakPointsService,
  ) {}

  ngOnInit() {
    this.layoutBreakPointService
      .subscribeLayoutChanges()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.desktopScreen = this.layoutBreakPointService.renderDesktop();
      });
  }

  protected formatDate(dateTime: Date, format: string) {
    return moment(dateTime, CONSTANTS.YYYY_MM_DD_HH_MM_A).format(format);
  }
}
